import React from 'react';
import Immutable from 'immutable';
import ParentBoundComponent from '../../components/parentboundcomponent';
import RenderContext from '../../components/definitions/rendercontext';
import Binder from '../../components/definitions/binder';
import ModuleContainer from '../../components/containers/modulecontainer';
import Button from '../../components/forms/button';
import SimpleDefinitionModel, { errorPath, errorMessageListPath } from './simpledefinitionmodel';
import { getLookup } from '../../data/lookupstore';
import styled from 'styled-components';
import {defaultTheme} from '../../data/themes';
import { getPhrase } from '../../data/phrases';

const EMPTY_MAP = Immutable.Map({});



export default class SimpleDefinitionModule extends ParentBoundComponent {
	constructor() {
		super();

		this.binder = new Binder({
			getData: this.getData,
			setData: this.setData,
			handleEvent: this.handleEvent,
			getLookup,
			errorPath,
			getModel: this.getModel,
			setModel: this.setModel
		}, this);

	}


	getModel() {
		return new SimpleDefinitionModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	render() {
		const data = this.getData();
		const ctx = new RenderContext(this.binder).withCalculatedProperties(data.get('calculateContextProperties'));
		const definition = data.get('definition');
		if (!definition) {
			return null;
		}
		return definition.render(ctx);
	}
}

